var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.07 15.7526C29.07 14.6409 28.9779 13.8296 28.7787 12.9883H15.8252V18.006H23.4286C23.2754 19.2529 22.4476 21.1308 20.608 22.3927L20.5822 22.5607L24.6779 25.6701L24.9616 25.6978C27.5676 23.3392 29.07 19.8688 29.07 15.7526Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.825 28.973C19.55 28.973 22.6772 27.7711 24.9614 25.6979L20.6078 22.3928C19.4428 23.189 17.8791 23.7448 15.825 23.7448C12.1766 23.7448 9.08004 21.3863 7.97621 18.1263L7.81441 18.1397L3.55569 21.3697L3.5 21.5214C5.76875 25.9382 10.429 28.973 15.825 28.973Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97615 18.1263C7.68489 17.2851 7.51633 16.3836 7.51633 15.4522C7.51633 14.5208 7.68489 13.6194 7.96082 12.7781L7.95311 12.599L3.64101 9.31711L3.49993 9.38287C2.56486 11.2157 2.02832 13.2739 2.02832 15.4522C2.02832 17.6306 2.56486 19.6887 3.49993 21.5215L7.97615 18.1263Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8251 7.1595C18.4157 7.1595 20.1633 8.25617 21.1598 9.17264L25.0535 5.44691C22.6621 3.26857 19.5501 1.93152 15.8251 1.93152C10.429 1.93152 5.76876 4.96615 3.5 9.38288L7.96091 12.7781C9.08008 9.51814 12.1766 7.1595 15.8251 7.1595Z",
    fill: "#EB4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ede2b9643567d090d31c3d0d23c21023.svg";
export { ForwardRef as ReactComponent };